module.exports = __webpack_public_path__ + "images/the-professional-ef8d9b23417c8805b1ec8dd177e5247c.png";